export function countdown() {
  const countdownContainer = document.querySelector("#countdown");
  if(countdownContainer != null)
  {
    window.onload = countdownContainer.style.right = "0";
    countdownContainer.style.transition = "1.5s";
  }
}
